import { defineStore } from "pinia";
import { useMenusStore } from "./sidebar";
import { showError, showInfo, showSuccess } from "@/utils/toastr";

export const useWebScocketStore = defineStore("websocket", {
    state: () => ({
        socket: null,
    }),
    actions: {
        initializeWebSocket() {
            if (!this.socket) {
                this.socket = new WebSocket("ws://localhost:8080");

                this.socket.onopen = () => {
                    showSuccess("WebSocket connecté super !")
                };

                this.socket.onmessage = (event) => {
                    try {
                        const message = JSON.parse(event.data);
                        showInfo(`Mise à jour reçue ${message}`);

                        if (message.type === 'menus_update') {
                            useMenusStore().menuList = message.data;
                        }
                    } catch (error) {
                        showError(`Erreur lors du parsing du message webSocket : ${error.message || error}`);
                    }
                };

                this.socket.onclose = () => {
                    showInfo("Connexion WebSocket fermée !")
                    setTimeout(() => {
                        this.initializeWebSocket();
                    }, 1000);
                };

                this.socket.onerror = (error) => {
                    showError(`Erreur WebSocket : ${error}`);
                };
            }
        }
    }
});